import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { IdeaEntry } from "@/components/IdeaEntry";

export default function FormPage() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200/70 bg-white/80 backdrop-blur-xl sticky top-0 z-20">
        <div className="max-w-2xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => nav("/")} className="flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900" data-testid="form-home-btn">
            <ArrowLeft className="h-4 w-4" /> Startseite
          </button>
          <Logo size="sm" />
          <span className="w-16" />
        </div>
      </header>
      <main className="max-w-xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>
            Kostenlose KI-Ersteinschätzung
          </h1>
          <p className="mt-3 text-slate-600">In ca. 60 Sekunden – beschreibe kurz deine Idee, den Rest klären wir später.</p>
        </div>
        <IdeaEntry />
      </main>
    </div>
  );
}
